/**
 * @file
 * Back to top button (html.html.twig, _back_to_top.scss).
 *
 * Shown (.is-visible) once the page has scrolled past the button's
 * data-threshold (theme settings > Back to top). Activating it scrolls to
 * the top - smoothly, unless the visitor prefers reduced motion - and moves
 * keyboard focus back to the top of the page, so the next Tab starts from
 * the beginning (the skip link) rather than from the bottom.
 */
(function (Drupal, once) {

  'use strict';

  Drupal.behaviors.layeroneBackToTop = {
    attach: function (context) {
      once('back-to-top', '[data-back-to-top]', context).forEach(function (button) {
        const threshold = parseInt(button.dataset.threshold, 10) || 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        let ticking = false;
        function update() {
          ticking = false;
          button.classList.toggle('is-visible', window.scrollY > threshold);
        }
        window.addEventListener('scroll', function () {
          if (!ticking) {
            ticking = true;
            // A short timer rather than requestAnimationFrame, which
            // browsers pause in background tabs.
            setTimeout(update, 50);
          }
        }, { passive: true });
        update();

        button.addEventListener('click', function () {
          window.scrollTo({ top: 0, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
          // Focus the top of the page without jumping again.
          const top = document.body;
          top.setAttribute('tabindex', '-1');
          top.focus({ preventScroll: true });
          top.addEventListener('blur', function () {
            top.removeAttribute('tabindex');
          }, { once: true });
        });
      });
    },
  };

})(Drupal, once);
